// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__34gVY","footer":"ModalInfo_footer__1XFfF"};